import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { Variables } from '../styles/Variables'
import media from 'css-in-js-media'

const LanguageSwitcher = styled.div`
  
    ${media('<desktop')} {
        display: flex;
        width: 100%;
        justify-content: flex-start;
        margin-top: 30px;    
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        letter-spacing: 0.005em;
    }
`

export const LanguageLinks = styled.ul`
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
`

const LanguageLinkWrap = styled.li`
    display: flex;
    align-items: center;
    &:after {
        content: "";
        width: 2px;
        height: 80%;
        background: ${Variables.color.white};
        display: inline-block;
        margin: 0 15px;

        ${media('<desktop')} {
            height: 60%;
        }

    }
    &:last-child {
        &:after {
            display: none ;
        }
    }
`

const LanguageLink = styled(Link)`
    color: ${Variables.color.black};
    text-decoration: none;
    text-transform: uppercase;
    /* border-bottom: 1px solid; */
    /* border-color: ${(props) => (props.selected ? Variables.color.plaster : 'transparent')}; */
`

const SelectLanguage = (props) => {
    const links = props.langs.map((lang) => (
        <LanguageLinkWrap key={lang.langKey}>
            <LanguageLink
                to={lang.link}
                key={lang.langKey}
                selected={lang.selected}
            >
                {lang.langKey == 'en-GB' ? 'EN' : lang.langKey}
            </LanguageLink>
        </LanguageLinkWrap>
    ))

    return (
        <LanguageSwitcher {...props}>
            <header>
                <FormattedMessage id="selectLanguage" />
            </header>
            <LanguageLinks>{links}</LanguageLinks>
        </LanguageSwitcher>
    )
}

SelectLanguage.propTypes = {
    langs: PropTypes.array,
}

export default SelectLanguage
